import { TbListDetails } from "solid-icons/tb";
import { For } from "solid-js";
import { COMPLIANCE_BADGES } from "~/components/marketing/MarketingFooter";
import { BRAND_TEXT } from "~/components/marketing/ui";
import { useI18n } from "~/i18n";
import type { TranslationKey } from "~/i18n/translations";

const AUDIT: { time: string; name: string; event: TranslationKey }[] = [
  { time: "10:44:12", name: "Alex", event: "marketing.features.trust.audit_row1" },
  { time: "10:43:58", name: "Priya", event: "marketing.features.trust.audit_row2" },
  { time: "10:41:05", name: "Alex", event: "marketing.features.trust.audit_row3" },
  { time: "09:12:40", name: "Dana", event: "marketing.features.trust.audit_row4" },
];

/** The certifications beside a slice of the org audit log. */
export const TrustVisual = () => {
  const { t } = useI18n();
  return (
    <div class="grid gap-4 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
      <a
        href="https://trust.chief.bot"
        target="_blank"
        rel="noopener noreferrer"
        class="group flex flex-col justify-between gap-8 rounded-3xl border border-primary-border bg-panel p-6 transition-colors hover:border-brand-border focus-visible:ring-2 focus-visible:ring-brand focus-visible:outline-none sm:p-8"
      >
        <span class="text-lg font-semibold">{t("marketing.home.trust.certs")}</span>
        <span class="flex flex-wrap items-center gap-4">
          <For each={COMPLIANCE_BADGES}>
            {(badge) => <img src={badge.src} alt={t(badge.label)} loading="lazy" class="h-20 w-auto" />}
          </For>
        </span>
        <span class={`text-sm font-semibold group-hover:underline ${BRAND_TEXT}`}>
          {t("marketing.home.trust.trust_center")} <span aria-hidden="true">→</span>
        </span>
      </a>
      <figure class="overflow-hidden rounded-3xl border border-primary-border bg-tile">
        <figcaption class="flex items-center gap-2 border-b border-primary-border bg-panel px-5 py-3 text-sm font-semibold">
          <TbListDetails class="size-4 text-secondary-text" aria-hidden="true" />
          {t("marketing.features.trust.audit_label")}
        </figcaption>
        <ul class="divide-y divide-primary-border font-mono text-xs sm:text-[13px]">
          <For each={AUDIT}>
            {(row) => (
              <li class="flex gap-4 px-5 py-3">
                <span class="shrink-0 text-muted-text tabular-nums">{row.time}</span>
                <span class="min-w-0">
                  <span class="font-semibold">{row.name}</span> <span class="text-secondary-text">{t(row.event)}</span>
                </span>
              </li>
            )}
          </For>
        </ul>
      </figure>
    </div>
  );
};
